import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicantWelcomeComponent } from './applicant-welcome.component';
import { PasswordModule } from 'primeng/password';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';



@NgModule({
  declarations: [
    ApplicantWelcomeComponent
  ],
  imports: [
    CommonModule,
    CheckboxModule,
    InputTextModule,
    FormsModule,
    PasswordModule,
    PanelModule,
    DropdownModule,
    SelectButtonModule,
    ButtonModule,
    TranslateModule,
    ToastModule
  ]
})
export class ApplicantWelcomeModule { }
